export function signOut() {
  try {
    // Clear all stored data
    window.localStorage.removeItem('fm_token');
    window.localStorage.removeItem('role');
    window.localStorage.removeItem('loggedInAs');
    
    // Clear any other local storage items
    window.localStorage.clear();
    
    // Redirect to login page
    window.location.href = '/login';
  } catch (error) {
    console.error('Error during sign out:', error);
    // Fallback: reload page
    window.location.reload();
  }
}
